module.exports = __webpack_public_path__ + "static/media/pompka_on.655706c9.svg";